import { useUpdateTodoTask } from '../mutations';
import { useAuthContext } from '../context';
import { TaskLabel, TodoAppFrom } from '@demind-inc/core';

export const useUpdateTaskLabelsSet = () => {
  const { updateTodoTask, isPending: isUpdatingTaskLabel } = useUpdateTodoTask();
  const { user } = useAuthContext();

  const handleUpdateTaskLabel = async (taskId: string, boardId: string, newLabels: TaskLabel[], appFrom: TodoAppFrom) => {
    await updateTodoTask({
      userId: user.userId,
      boardId,
      taskId,
      newTaskInfo: {
        labels: newLabels,
        appFrom,
      },
    });
  };

  return { handleUpdateTaskLabel, isUpdatingTaskLabel };
};
